import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const SegmentIcon = (props: IconProps) => (
  // Tightened from the source's 0 0 64 64 to the path's actual bounds so
  // boxSize matches the visible icon (no ~22% empty margin).
  <ChakraIcon viewBox="10 10 44 44" {...props}>
    <path
      d="M27.9888756,18.0222481 L27.9888756,36.0111251 L45.9777521,36.0111251 C45.9777521,40.7818213 44.0839147,45.3569963 40.7093564,48.7295432 C37.3368611,52.1042027 32.7615831,54 27.9888756,54 C23.2181795,54 18.6430046,52.1041001 15.2704577,48.7295432 C11.8957973,45.3570478 10,40.7818213 10,36.0111251 C10,31.2383659 11.8959004,26.6631909 15.2704577,23.2906439 C18.642953,19.916034 23.2181795,18.0222481 27.9888756,18.0222481 Z M33.4666667,10 C38.9129215,10 44.1353379,12.1638916 47.9849426,16.0150574 C51.8359883,19.8649824 54,25.0874788 54,30.5333333 L33.4666667,30.5317322 Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </ChakraIcon>
)

export default SegmentIcon
